import Vue     from 'vue';
import Router  from 'vue-router';
import Welcome from './components/welcome/component.vue';
import S3      from './components/connections/s3/component.vue';
import Demo    from './components/demo/component.vue';
import Read    from './components/read/component.vue';
import Upload  from './components/upload/component.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: './',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/s3',
      name: 's3',
      component: S3,
      props: true
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo,
      props: true
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload,
      props: true
    },
    {
      path: '/read',
      name: 'read',
      component: Read,
      props: true
    },
    {
      path: '/',
      name: 'welcome',
      component: Welcome,
      props: true
    }
  ]
});
